/**
 * ClubProfile — profil członka + wylogowanie.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useClubAuth } from './ClubApp';
import { TIERS } from './clubApi';

export default function ClubProfile() {
  const navigate = useNavigate();
  const { member, logout } = useClubAuth();
  const tierLabel = TIERS[member.tier]?.label || member.tier;
  const tierColor = TIERS[member.tier]?.color || 'var(--club-gold)';

  return (
    <div className="club-shell">
      <div className="club-brand">
        <div className="club-brand-logo" style={{ border: `2px solid ${tierColor}` }}>
          {(member.firstName || '?').charAt(0).toUpperCase()}
        </div>
        <h1 className="club-brand-name" style={{ fontSize: 18, letterSpacing: 1 }}>
          {member.firstName}
        </h1>
        <div className="club-brand-sub" style={{ color: tierColor }}>{tierLabel} MEMBER</div>
      </div>

      <div className="club-card">
        <div className="club-section-title" style={{ marginTop: 0 }}>Dane konta</div>
        <Row label="E-mail" value={member.email} />
        <Row label="Telefon" value={member.phone || '—'} />
        <Row label="Punkty" value={`${(member.points_total ?? 0).toLocaleString('pl-PL')} pkt`} accent />
        <Row label="Poziom" value={tierLabel} accent />
      </div>

      <div className="club-card">
        <div className="club-section-title" style={{ marginTop: 0 }}>Zgody marketingowe</div>
        <Row label="Regulamin" value={member.consents?.terms ? '✅ Tak' : '—'} small />
        <Row label="RODO" value={member.consents?.rodo ? '✅ Tak' : '—'} small />
        <Row label="Marketing e-mail" value={member.consents?.marketing_email ? '✅ Tak' : '❌ Nie'} small />
        <Row label="Marketing SMS" value={member.consents?.marketing_sms ? '✅ Tak' : '❌ Nie'} small />
      </div>

      <button
        className="club-btn club-btn-secondary"
        onClick={() => navigate('/mrjerryclub/paragony')}
        data-testid="club-profile-receipts-btn"
        style={{ marginBottom: 10 }}
      >
        📋 Historia paragonów
      </button>

      <button
        className="club-btn club-btn-secondary"
        onClick={logout}
        data-testid="club-logout-btn"
      >
        🚪 Wyloguj się
      </button>

      <p className="club-help" style={{ textAlign: 'center', marginTop: 20 }}>
        MR JERRY CLUB · v1.0 · Faza MVP
      </p>
    </div>
  );
}

const Row = ({ label, value, accent, small }) => (
  <div style={{
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px 0',
    borderBottom: '1px solid var(--club-border-soft)',
    fontSize: small ? 12 : 14,
  }}>
    <span style={{ color: 'var(--club-text-muted)' }}>{label}</span>
    <span style={{ color: accent ? 'var(--club-gold)' : 'var(--club-text)', fontWeight: accent ? 800 : 500 }}>
      {value}
    </span>
  </div>
);
